/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Cache
 */

module.exports = {

    BaseCache: require('./BaseCache'),
    CacheManager: require('./CacheManager')

};



//////////////////
// WEBPACK FOOTER
// ./cache/index.js
// module id = 465
// module chunks = 0